import CircularProgress from '@mui/material/CircularProgress';
import { FC } from 'react';
import useSyncTimeoutIndicator from './SyncTimeoutIndicator.hook';
import { SyncTimeoutIndicatorProps } from './SyncTimeoutIndicator.types';
import Box from 'yoda-ui/components/Box';
import Typography from 'yoda-ui/components/Typography';
import { YodaColors, YodaSpacing } from 'yoda-ui/yodaTheme';

const SyncTimeoutIndicator: FC<SyncTimeoutIndicatorProps> = (props) => {
  const { t, timeRemaining } = useSyncTimeoutIndicator(props);

  if (timeRemaining <= 0) return null;

  return (
    <Box display="flex" alignItems="center" justifyContent="center" marginBottom={ YodaSpacing.small }>
      <CircularProgress size={ 16 } sx={ { marginRight: YodaSpacing.xxSmall, color: YodaColors.blue7 } } />
      <Typography variant="body2" color="textSecondary">
        { t('maya_sync_timeout_remaining', { defaultValue: 'Next sync will be available in {{seconds}}s', seconds: timeRemaining }) }
      </Typography>
    </Box>
  );
};

export default SyncTimeoutIndicator;
